import { Model } from '@/clients/http'

import { DeliveryLocationTypeHttpParams, DeliveryLocationTypeResponses } from '@/types'

export class DeliveryLocationTypeModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_DELIVERY_LOCATION_TYPE_LIST',
    GET_BY_ID: 'GET_DELIVERY_LOCATION_TYPE_BY_ID',
    CREATE: 'CREATE_DELIVERY_LOCATION_TYPE',
    UPDATE: 'UPDATE_DELIVERY_LOCATION_TYPE',
    DELETE: 'DELETE_DELIVERY_LOCATION_TYPE',
  }

  public static readonly endpoints = {
    getList: (props?: DeliveryLocationTypeHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/delivery-location-type',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: DeliveryLocationTypeHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/delivery-location-type/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: DeliveryLocationTypeHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/delivery-location-type',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: DeliveryLocationTypeHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/delivery-location-type/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: DeliveryLocationTypeHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/delivery-location-type/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: DeliveryLocationTypeHttpParams.GetList) => {
    return this.createHttpRequest<
      DeliveryLocationTypeResponses.GetList,
      DeliveryLocationTypeResponses.GetListError
    >({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: DeliveryLocationTypeHttpParams.Create) => {
    return this.createHttpRequest<
      DeliveryLocationTypeResponses.Create,
      DeliveryLocationTypeResponses.CreateError
    >({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: DeliveryLocationTypeHttpParams.Update) => {
    return this.createHttpRequest<
      DeliveryLocationTypeResponses.Update,
      DeliveryLocationTypeResponses.UpdateError
    >({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly delete = async (props: DeliveryLocationTypeHttpParams.Delete) => {
    return this.createHttpRequest<
      DeliveryLocationTypeResponses.Delete,
      DeliveryLocationTypeResponses.DeleteError
    >({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
